

















































































































































































































































































import {
  Button,
  Icon2,
  InputContainer,
  Toggle,
  SortableTable,
} from "@micad/vue-components";

import { Client, getClientTypeOptions } from "@/assets/js/constants";
import { defineComponent, reactive, watch } from "@vue/composition-api";
import router from "@/router";
import Loading from "@/components/Loading.vue";
import ModalContainer from "@/components/ModalContainer.vue";
import {
  deleteClient,
  getClientConfig,
  getClientDetails,
  getClients,
  getSubClients,
  updateClientConfig,
  updateClientDetails,
} from "@/data/repos/client";
import { requestWithNotification } from "@/notifications";
import {
  TableColumn,
  TableFilter,
} from "@micad/vue-components/src/common/interfaces";
import { QIcon } from "quasar";
import { canIUse } from "@/modules/auth";
import "@micad/vue-components/src/styles/components/SearchableSelect.scss";

const columns = [
  {
    name: "key",
    label: "Client key",
    align: "left",
    field: (row: Client) => row.key,
    classes: "primary",
    sortable: true,
    filter: true,
    customBodyRender: (row: Client) =>
      `<p class="hover:cursor-pointer">${row.key || ""}</p>`,
  },
  {
    name: "name",
    label: "Name",
    align: "left",
    field: (row: Client) => row.name || "",
    classes: "primary",
    sortable: true,
    filter: true,
  },
  {
    name: "logoUrl",
    label: "Logo URL",
    align: "left",
    field: (row: Client) => row.logoUrl,
    classes: "primary",
    sortable: true,
    filter: true,
    customBodyRender: (row: Client) =>
      `<a target="_blank" href="${row.logoUrl}">${row.logoUrl || ""}</a>`,
  },
  {
    name: "active",
    label: "Active",
    align: "center",
    field: (row: Client) => row.active || false,
    classes: "primary",
    sortable: true,
    filter: true,
    customBodyRender: (row: Client) =>
      `<input  type="checkbox" ${
        row.active ? "checked" : ""
      } onclick="return false;"/>`,
  },
];

export default defineComponent({
  name: "ClientDetails",
  methods: { canIUse },
  components: {
    QIcon,
    ModalContainer,
    Loading,
    Button,
    InputContainer,
    Toggle,
    Icon2,
    SortableTable,
  },
  setup(p, ctx) {
    const toggleEditDetails = () => (state.editDetails = !state.editDetails);
    const toggleEditConfig = () => (state.editConfig = !state.editConfig);
    const saveDetails = () =>
      requestWithNotification(
        updateClientDetails({
          ...state.clientEdit,
          parentId: state.parentClient.id,
        }),
        "Client details updated",
        "Client details were not updated. Internal server error.",
        () => {
          state.clientEdit.parentId = state.parentClient.id;
          state.clientEdit.parentKey = state.parentClient.key;
          state.clientEdit.parentName = state.parentClient.name;
          state.client = state.clientEdit;
          state.editDetails = false;
        }
      );

    const saveConfig = () => {
      requestWithNotification(
        updateClientConfig({
          text: state.clientConfigEdit,
          key: router.currentRoute.params.key,
        }),
        "Client details updated",
        "Client details were not updated. Internal server error.",
        () =>
          (state.clientConfig = state.clientConfigEdit) &&
          (state.editConfig = false)
      );
    };
    const delClient = (confirmed = false) => {
      if (confirmed) {
        requestWithNotification(
          deleteClient(state.client.key),
          "Client deleted",
          "Client deletion failed. Internal server error.",
          () => router.push({ name: "Clients" })
        );
      } else {
        state.showDeleteClientDialog = true;
      }
    };
    const createSubClient = () => {
      router.push({
        name: "ClientCreate",
        params: { parentKey: state.client.key },
      });
    };
    const state = reactive({
      client: {
        key: "",
        name: "",
        type: "",
        logoUrl: "",
        active: false,
      } as Client,
      clientEdit: {} as Client,
      editDetails: false,
      loaded: false,
      editConfig: false,
      clientConfig: "client: config",
      clientConfigEdit: "client: config edit",
      subClients: [] as Client[],
      selectedSubClient: undefined as Client | undefined,
      columns,
      actions,
      filters: [] as TableFilter[],
      showDeleteClientDialog: false,
      showAddSubClient: false,
      parentClientList: [] as Client[],
      parentClient: {} as Client,
      clientTypeOptions: getClientTypeOptions(),
      clientTypeSelected: "",
      toggleEditDetails,
      toggleEditConfig,
      saveDetails,
      saveConfig,
      delClient,
      createSubClient,
      goBack: () => router.back(),
      resetParentClient: () => (state.parentClient = {} as Client),
    });
    watch(
      () => state.clientTypeSelected,
      (v) => (state.clientEdit.type = v === "" ? undefined : v)
    );
    const updateParentClient = () => {
      if (state.client.parentKey)
        state.parentClientList.forEach(
          (c) =>
            (state.parentClient =
              state.client.parentKey === c.key ? c : state.parentClient)
        );
    };

    function refresh() {
      state.client.parentKey = "";
      state.client.parentId = undefined;
      state.client.parentName = undefined;
      state.parentClient = {} as Client;
      setTimeout(async () => {
        state.loaded = false;
        Object.assign(
          state.client,
          (await getClientDetails(router.currentRoute.params.key)).payload
        );
        Object.assign(state.clientEdit, state.client);
        getClients({ includeChildren: true, hideInactive: true }).then(
          (data) => {
            state.parentClientList = data.payload || [];
            updateParentClient();
          }
        );
        state.clientTypeSelected = state.client.type || "";
        state.loaded = true;
      }, 0);

      setTimeout(async () => {
        state.clientConfig =
          (await getClientConfig(router.currentRoute.params.key)).payload
            ?.text || "";
        state.clientConfigEdit = state.clientConfig;
        state.loaded = true;
      }, 0);

      setTimeout(async () => {
        state.subClients = (
          (await getSubClients(router.currentRoute.params.key)).payload || []
        ).sort((a: Client, b: Client) =>
          a.key.toLowerCase() > b.key.toLowerCase() ? 1 : -1
        );
      });
    }
    refresh();
    watch(() => ctx.root.$route.path, refresh);
    async function actions(col: TableColumn) {
      switch (col.name) {
        case "key":
          await router.push({
            name: "ClientDetails",
            params: { key: String(col.value), refresh: "true" },
          });
          break;
        case "name":
          console.log("col", JSON.stringify(col));
          break;
      }
    }

    return state;
  },
});
